import { Steps, Step } from 'components/Docs/Steps';
import iOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import StepCreateExperiment from "../../../../contents/docs/experiments/installation/_snippets/step-create-experiment.mdx";
import StepAddPrimaryMetric from "../../../../contents/docs/experiments/installation/_snippets/step-add-primary-metric.mdx";
import StepValidateExperimentEvents from "../../../../contents/docs/experiments/installation/_snippets/step-validate-experiment-events.mdx";
import StepValidateFeatureFlags from "../../../../contents/docs/experiments/installation/_snippets/step-validate-feature-flags.mdx";
import StepEvaluateExperimentResults from "../../../../contents/docs/experiments/installation/_snippets/step-evaluate-experiment-results.mdx";
import Wizard from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import Tab from "components/Tab";
import * as React from 'react';
export default {
  Steps,
  Step,
  iOSInstall,
  StepCreateExperiment,
  StepAddPrimaryMetric,
  StepValidateExperimentEvents,
  StepValidateFeatureFlags,
  StepEvaluateExperimentResults,
  Wizard,
  Tab,
  React
};